import { Chip, Tooltip } from '@mui/material';
import Icon from '../../components/Icon';
import { QuestionStatus } from '../constants/QuestionStatus';

const statusColorMap: Record<QuestionStatus, 'success' | 'warning'> = {
    [QuestionStatus.Answered]: 'success',
    [QuestionStatus.Pending]: 'warning',
};

interface QuestionStatusChipProps {
    status: QuestionStatus;
}

const QuestionStatusChip: React.FC<QuestionStatusChipProps> = ({ status }) => {
    return (
        <Tooltip title={`Status of request: ${status}`}>
            <Chip
                icon={<Icon name={status} />}
                label={status}
                variant='outlined'
                color={statusColorMap[status]}
                sx={
                    status === QuestionStatus.Pending
                        ? {
                              '@keyframes statusPulse': {
                                  '0%, 100%': { boxShadow: '0 0 0 0 rgba(237, 108, 2, 0)' },
                                  '50%': { boxShadow: '0 0 0 5px rgba(237, 108, 2, 0.18)' },
                              },
                              animation: 'statusPulse 2.2s ease-in-out infinite',
                          }
                        : {}
                }
            />
        </Tooltip>
    );
};

export default QuestionStatusChip;
